module.exports = __webpack_public_path__ + "static/media/14UNEP26.ff070279.jpg";